/* tslint:disable */
/* eslint-disable */
/**
 * Coworker IAM API
 * Provides coworker identity and access management functionalities
 *
 * The version of the OpenAPI document: 1.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CoworkerPermissionsDto
 */
export interface CoworkerPermissionsDto {
    /**
     * Response type
     * @type {string}
     * @memberof CoworkerPermissionsDto
     */
    type: string;
    /**
     * List of authorization strings
     * @type {Array<string>}
     * @memberof CoworkerPermissionsDto
     */
    authorizations: Array<string>;
}

/**
 * Check if a given object implements the CoworkerPermissionsDto interface.
 */
export function instanceOfCoworkerPermissionsDto(value: object): boolean {
    if (!('type' in value)) return false;
    if (!('authorizations' in value)) return false;
    return true;
}

export function CoworkerPermissionsDtoFromJSON(json: any): CoworkerPermissionsDto {
    return CoworkerPermissionsDtoFromJSONTyped(json, false);
}

export function CoworkerPermissionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoworkerPermissionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'authorizations': json['authorizations'],
    };
}

export function CoworkerPermissionsDtoToJSON(value?: CoworkerPermissionsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
        'authorizations': value['authorizations'],
    };
}

